import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_API_URL || window.location.origin;
export const socket = io(SOCKET_URL, {
  path: '/socket.io',    // adjust if you mounted Socket.IO on a custom path
  transports: ['websocket'],
  // Do not open a WebSocket just because this module was imported by App.
  // The live public site imports shared components that reference this socket;
  // eager connections from every visitor add bandwidth/CPU pressure and can
  // amplify DB pool exhaustion when room joins happen after login.
  autoConnect: false,
});

export function socketAuthPayload(extra = {}) {
  const token = window.localStorage.getItem('token');
  return {
    ...extra,
    ...(token ? { token } : {}),
  };
}

export function ensureSocketConnected() {
  const token = window.localStorage.getItem('token');
  socket.auth = token ? { token } : {};
  if (!socket.connected) {
    socket.connect();
  }
}

const rawEmit = socket.emit.bind(socket);
socket.emit = (...args) => {
  const eventName = args[0];
  if (
    !socket.connected &&
    typeof eventName === 'string' &&
    eventName.startsWith('leave_')
  ) {
    return socket;
  }
  ensureSocketConnected();
  return rawEmit(...args);
};

const rawOnce = socket.once.bind(socket);
socket.once = (eventName, ...args) => {
  const result = rawOnce(eventName, ...args);
  if (eventName === 'connect') {
    ensureSocketConnected();
  }
  return result;
};

socket.on("connect", () => {
  console.log("[socket] connect id=", socket.id);
});
socket.on("disconnect", (reason) => {
  console.log("[socket] disconnect reason=", reason);
});
socket.on("connect_error", (err) => {
  console.log("[socket] connect_error", err?.message, err);
});
socket.io.on("reconnect_attempt", (n) => console.log("[socket] reconnect_attempt", n));
socket.io.on("reconnect", (n) => console.log("[socket] reconnect", n));
socket.io.on("reconnect_error", (e) => console.log("[socket] reconnect_error", e));

socket.io.on('reconnect', () => {
  socket.emit('join_package_updates');
});

const rawOn = socket.on.bind(socket);
socket.on = (eventName, ...args) => {
  const result = rawOn(eventName, ...args);
  if (typeof eventName === 'string' && !['disconnect', 'connect_error', 'error'].includes(eventName)) {
    ensureSocketConnected();
  }
  return result;
};
